<template>
    <div class="content">
        <nav class="tab">

<!--            <div>-->
<!--                <el-select v-model="queryParam.stationCode" placeholder="请选择站点" size="mini" @change="getList">-->
<!--                    <el-option v-for="item in siteList" :label="item.stationName" :value="item.stationCode"-->
<!--                               :key="item.id"></el-option>-->
<!--                </el-select>-->
<!--            </div>-->

            <div class="center"></div>

            <a-button class="btn" type="primary" size="small" @click="getList">
                查询
            </a-button>
            <a-button class="btn" type="primary" size="small" @click="add">
                新增
            </a-button>
        </nav>

        <div style="overflow: auto;height:  90%">
            <el-table
                    :data="tableData"
                    style="width: 100%">
                <el-table-column
                        align="center"
                        label="站点"
                >
                    <template>
                        宿州市
                    </template>
                </el-table-column>
                <el-table-column
                        prop="name"
                        align="center"
                        label="仪器名称"
                >
                </el-table-column>
                <el-table-column
                        prop="param"
                        align="center"
                        label="参数名称"
                >
                </el-table-column>
                <el-table-column
                        prop="min"
                        align="center"
                        label="最小阈值"
                >
                </el-table-column>
                <el-table-column
                        prop="max"
                        align="center"
                        label="最大阈值"
                >
                </el-table-column>
                <el-table-column
                        label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button
                                size="mini"
                                type="text"
                                icon="el-icon-edit"
                                @click="handleUpdate(scope.row)"
                        >修改
                        </el-button>
                        <el-button
                                size="mini"
                                type="text"
                                icon="el-icon-delete"
                                @click="handleDelete(scope.row)"
                        >删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!--        <div class="elpagination">-->
        <!--            <el-pagination-->
        <!--                    size="mini"-->
        <!--                    @size-change="handleSizeChange"-->
        <!--                    @current-change="handleCurrentChange"-->
        <!--                    :current-page.sync="queryParam.page"-->
        <!--                    :page-size="queryParam.pageSize"-->
        <!--                    layout="prev, pager, next, jumper"-->
        <!--                    background-->
        <!--                    :total="pagination.total">-->
        <!--            </el-pagination>-->
        <!--        </div>-->

        <el-dialog :title="title" :visible.sync="dialogFormVisible" :before-close="beforeClose">
            <el-form :model="form" ref="form" label-width="80px" :rules="rules" class="MyForm">
                <el-form-item label="站点" prop="stationCode">
<!--                    <el-select v-model="form.stationCode" :disabled="form.id" placeholder="请选择站点" style="width:100%">-->
<!--                        <el-option v-for="item in siteList" :label="item.stationName" :value="item.stationCode"-->
<!--                                   :key="item.id"></el-option>-->
<!--                    </el-select>-->
                    <el-select v-model="form.stationCode" :disabled="form.id" placeholder="请选择站点" style="width:100%">
                        <el-option label="宿州市" value="341300"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="仪器名称" prop="name">
                    <el-select v-model="form.name" placeholder="请选择仪器名称" :disabled="form.id" style="width:100%">
                        <el-option label="六要素" value="六要素"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="参数名称" prop="param">
                    <el-select v-model="form.param" placeholder="请选择参数名称" :disabled="form.id" style="width:100%">
                        <el-option label="AQI" value="AQI"></el-option>
                        <el-option label="PM25" value="PM25"></el-option>
                        <el-option label="PM10" value="PM10"></el-option>
                        <el-option label="SO2" value="SO2"></el-option>
                        <el-option label="NO2" value="NO2"></el-option>
                        <el-option label="CO" value="CO"></el-option>
                        <el-option label="NO" value="NO"></el-option>
                        <el-option label="O3" value="O3"></el-option>
                        <el-option label="O38H" value="O38H"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="最小阈值">
                    <el-input v-model="form.min" placeholder="请输入最小阈值"></el-input>
                </el-form-item>
                <el-form-item label="最大阈值">
                    <el-input v-model="form.max" placeholder="请输入最大阈值"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import url from "../utils/UrlApi"

    export default {
        name: "ThresholdManagement",
        data() {
            return {
                tableData: [],
                queryParam: {
                    page: 1,
                    pageSize: 10,
                    stationCode: '',
                },
                pagination: {},
                dialogFormVisible: false,
                form: {
                    stationCode: '',
                    name: '',
                    param: '',
                    max: '',
                    min: '',
                },
                rules: {
                    name: [
                        {required: true, message: "目录名称不能为空", trigger: "blur"}
                    ]
                },
                title: '',
                siteList: []
            }
        },
        created() {
            this.getList()
            this.getSiteList()
        },
        methods: {

            // 获取站点列表
            getSiteList() {
                this.$http.get(url.thresholdStationsList).then(res => {
                    console.log(res)
                    if (res.data.code === "200") {
                        this.siteList = res.data.data
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            // 获取列表
            getList() {
                this.$http.get(url.thresholdList,{
                    params: this.queryParam
                }).then(res => {
                    console.log(res)
                    if (res.data.code === "200") {
                        this.tableData = res.data.data
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },

            add() {
                this.getSiteList()
                this.dialogFormVisible = true
                this.title = '新增阈值'
                this.form = {
                    stationCode: '',
                    name: '',
                    param: '',
                    max: '',
                    min: '',
                }
            },

            submit() {
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        if (this.form.id != null) {
                            this.$http.post(url.thresholdUpdate, this.form).then(res => {
                                // console.log(res)
                                if (res.data.code === '200') {
                                    // console.log(res)
                                    this.dialogFormVisible = false
                                    this.$message.success('修改成功')
                                    this.getList()
                                } else {
                                    this.$message.error(res.data.message)
                                }

                            })
                        } else {
                            this.$http.post(url.thresholdSave, this.form).then(res => {
                                // console.log(res)
                                if (res.data.code === '200') {
                                    // console.log(res)
                                    this.$message.success('添加成功')
                                    this.dialogFormVisible = false
                                    this.getList()
                                } else {
                                    this.$message.error(res.data.message)
                                }

                            })
                        }
                    }
                });
            },


            handleUpdate(row) {
                this.form = row
                this.dialogFormVisible = true
                this.title = '修改阈值'
            },

            handleDelete(row) {
                this.$http.post(url.thresholdDelete, {id:row.id}).then(res => {
                    // console.log(res)
                    if (res.data.code === '200') {
                        // console.log(res)
                        this.$message.success('删除成功')
                        this.dialogFormVisible = false
                        this.getList()
                    } else {
                        this.$message.error(res.data.message)
                    }

                })
            },

            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.queryParam.pageSize = val
                this.getSiteList()
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
                this.queryParam.page = val
                this.getSiteList()
            },
            beforeClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {
                    });
            }
        }
    }
</script>

<style scoped lang="less">

    .content {
        width: 80%;
        margin: 30px auto;
        height: 100%;
        .tab {
            margin-bottom: 20px;
            display: flex;

            .center {
                flex: 1;
            }

            .btn {
                margin-left: 20px;
            }
        }
    }

    .elpagination {
        margin-top: 20px;
        text-align: right;
    }
</style>